// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I-vc","label":"styles_label__2Xr6p"};